import gql from 'graphql-tag';

export const VENDOR_OPPORTUNITIES_REVENUE = gql`
  query VendorOpportunitiesRevenue($input: VendorOpportunitiesRevenueInput!) {
    vendorOpportunitiesRevenue(input: $input) {
      total
      productsSoldCount
      totalAftermarketProfit
      totalFinanceInsuranceProfit
      revenues {
        vendorOpportunityId
        customerName
        locationBranch
        salesRep
        dealDate
        estimatedCloseDate
        createdDate
        dealAmount
        equipmentSalePrice
        equipmentCost
        equipmentGross
        equipmentMarginPercent
        financeUsed
        financeGross
        financeProfit
        financeMarginPercent
        internalFinanceTier
        lender
        docFeeAmount
        escSold
        escVendor
        escGross
        escCost
        escProfit
        gapSold
        gapVendor
        gapGross
        gapCost
        gapProfit
        insuranceSold
        insuranceVendor
        insuranceGross
        insuranceCost
        insuranceProfit
        roadsideSold
        roadsideVendor
        roadsideGross
        roadsideCost
        roadsideProfit
      }
    }
  }
`;
